import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { DocumentTitle } from 'shared/components';
import { AppointmentsFetchPendingPlaceholder } from 'modules/queues/common/components';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import EditAppointment from 'modules/appointmentsManagement/components/EditAppointment';

import theme from './EditAppointmentPage.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  sessionRequestStatus: PropTypes.string,
  match: PropTypes.object.isRequired,
  sessionInitialized: PropTypes.bool,
  screenHeight: PropTypes.any,
};

const defaultProps = {
  sessionRequestStatus: null,
  sessionInitialized: false,
  screenHeight: null,
};

const EditAppointmentPage = ({
  intl,
  sessionInitialized,
  sessionRequestStatus,
  match: { params: { appointmentId } },
  screenHeight,
}) => {
  return (
    <div className={ theme.root } style={{ height: screenHeight }}>
      <Choose>
        <When condition={ !sessionInitialized && (!sessionRequestStatus || sessionRequestStatus === requestsStatuses.pending) }>
          <AppointmentsFetchPendingPlaceholder />
        </When>
        <Otherwise>
          <EditAppointment appointmentId={ appointmentId } />
        </Otherwise>
      </Choose>
      <DocumentTitle title={ intl.formatMessage({ id: 'Patient.Appointment.EditAppointment.Page.Title', defaultMessage: '** Edit Appointment' }) } />
    </div>
  );
};

EditAppointmentPage.propTypes = propTypes;
EditAppointmentPage.defaultProps = defaultProps;

export default injectIntl(EditAppointmentPage);
